module.exports = __webpack_public_path__ + "static/media/logo-white-horizon.2776d528.svg";